import React, { useEffect, useState } from 'react';
import { pick } from 'ramda';
import VerticalGamesView from './VerticalGamesView';
import { useDeviceSelector } from '../../../../../store/hooks';

const GamesView = (props) => {
    const { gameCodes, isShowGameName, isShowPlayButtonOnHover, trackChangeGameClick, isInMissionsItemCard,
        updateCardHeight, imageMission, urlMission, missionStatus } = props;

    const deviceSelector = useDeviceSelector(pick(['isLandscape', 'isMobile', 'isTablet', 'isDesktop']));
    const [gameInfoObjects, setGameInfoObjects] = useState(gameCodes);

    useEffect(() => {
        setGameInfoObjects(gameCodes);
    }, [gameCodes]);

    const comparator = (a, b) => {
        if (a.gameCode < b.gameCode) {
            return -1;
        } else if (a.gameCode > b.gameCode) {
            return 1;
        }
        return 0;
    };

    const selectSuitableGame = (duplicates) => {
        const activeGame = duplicates.find((item) => {
            return item.isActive;
        });
        const notStartedGame = duplicates.filter((item) => {
            return item.isNotStarted;
        });
        const finishedGame = duplicates.find((item) => {
            return item.isFinished;
        });
        if (activeGame) {
            return activeGame;
        } else if (notStartedGame.length > 0) {
            // select suitable game
            return notStartedGame.sort((a, b) => a.timeToStart - b.timeToStart)[0];
        } else if (finishedGame) {
            return finishedGame;
        }
        return undefined;
    };

    const compareGameInfoObjects = (gameInfo1, gameInfo2) => {
        return gameInfo1.isNotStarted === gameInfo2.isNotStarted && gameInfo1.isFinished === gameInfo2.isFinished &&
            gameInfo1.isActive === gameInfo2.isActive && gameInfo1.timeToStart === gameInfo2.timeToStart;
    };

    const removeDuplicateGames = () => {
        const copyOfGameInfoObjects = [...gameInfoObjects];
        const sortedGamesRules = copyOfGameInfoObjects.sort(comparator);
        const duplicationCodes = [];
        for (let i = 0; i < sortedGamesRules.length - 1; i++) {
            if (sortedGamesRules[i + 1].gameCode === sortedGamesRules[i].gameCode) {
                duplicationCodes.push(sortedGamesRules[i].gameCode);
            }
        }
        let duplicationGames = [];
        for (let i = 0; i < duplicationCodes.length; i++) {
            duplicationGames = gameInfoObjects.filter((element) => {
                return element.gameCode === duplicationCodes[i];
            });
        }
        if (duplicationGames.length === 0) {
            return gameInfoObjects;
        }
        const suitableGameFromDuplications = selectSuitableGame(duplicationGames);
        const res = gameInfoObjects.filter((gameInfoObj) => gameInfoObj.gameCode
            !== suitableGameFromDuplications.gameCode
            || gameInfoObj.gameCode === suitableGameFromDuplications.gameCode
            && compareGameInfoObjects(gameInfoObj, suitableGameFromDuplications));
        return res.filter((value, index, self) =>
            index === self.findIndex(t => t.gameCode === value.gameCode)
        );
    };

    const addEmptySecondGameInCaseOfMissions = () => {
        const games = removeDuplicateGames();
        if (isInMissionsItemCard) {
            games.splice(1, 0, {});
        }
        return games;
    };

    return <div>
        <VerticalGamesView gameCodes={addEmptySecondGameInCaseOfMissions()} deviceSelector={deviceSelector}
                           isShowGameName={isShowGameName} isShowPlayButtonOnHover={isShowPlayButtonOnHover}
                           trackChangeGameClick={trackChangeGameClick} isInMissionsItemCard={isInMissionsItemCard}
                           updateCardHeight={updateCardHeight} imageMission={imageMission} urlMission={urlMission}
                           missionStatus={missionStatus}/>
    </div>;
};

export default GamesView;
